import { createFileRoute } from '@tanstack/react-router'
import { ErrorState } from '@/components/empty-state'
import { PageHeader } from '@/components/page-header'
import { Skeleton } from '@/components/ui/skeleton'
import { AccountsForm } from '@/features/accounting/accounts-form'
import { useAccountingSettings } from '@/features/accounting/api'
import { requirePermission } from '@/lib/route-guards'

/** Administración › Catálogo contable: cuentas de cada rol y política contable. */
export const Route = createFileRoute('/_app/admin/accounting')({
  beforeLoad: requirePermission('accounting:manage'),
  component: AccountingAccountsPage,
})

function AccountingAccountsPage() {
  const { data, isLoading, error, refetch } = useAccountingSettings()
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Administración"
        title="Catálogo contable"
        description="Cuenta de su catálogo para cada partida automática. El catálogo sugerido es un punto de partida: ajústelo con su contador."
      />
      {isLoading ? (
        <Skeleton className="h-96 rounded-xl" />
      ) : error || !data ? (
        <div className="rounded-xl border border-border bg-card">
          <ErrorState error={error} onRetry={() => void refetch()} />
        </div>
      ) : (
        <AccountsForm settings={data.settings} />
      )}
    </div>
  )
}
